// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-df60dd3a]{display:flex;flex-direction:column;margin:1rem 0}.wrapper #title[data-v-df60dd3a]{color:#161616;font-weight:700;font-size:14px}.wrapper #dimensions[data-v-df60dd3a]{color:#6f6f6f;font-size:12px}", ""]);
// Exports
module.exports = exports;
